/**
 * 添加节点对话框
 */

import React, { useMemo, useState } from 'react';
import { Modal, Form, Input, Select, message } from 'antd';
import { ContainerModal, CompsForm } from '@ms/shared-components';
import type { TreeNode } from '../utils/treeBuilder';

interface AddNodeModalProps {
  visible: boolean;
  type: string;
  parent?: TreeNode | null;
  onSuccess: () => void;
  onCancel: () => void;
}

const AddNodeModal: React.FC<AddNodeModalProps> = ({
  visible,
  type,
  parent,
  onSuccess,
  onCancel,
}) => {
  const [formRef, setFormRef] = useState<any>(null);

  // 根据类型获取表单配置
  const formItems = useMemo(() => {
    switch (type) {
      case 'page':
        return [
          {
            name: 'pageId',
            label: '页面ID',
            type: 'input' as const,
            rules: [{ required: true, message: '请输入页面ID' }],
          },
        ];
      case 'component':
        return [
          {
            name: 'componentId',
            label: '组件ID',
            type: 'input' as const,
            rules: [{ required: true, message: '请输入组件ID' }],
          },
          {
            name: 'name',
            label: '组件名称',
            type: 'input' as const,
            rules: [{ required: true, message: '请输入组件名称' }],
          },
          {
            name: 'type',
            label: '组件类型',
            type: 'select' as const,
            options: [
              { label: '图表', value: 'chart' },
              { label: '表格', value: 'table' },
              { label: '表单', value: 'form' },
              { label: '仪表盘', value: 'dashboard' },
            ],
          },
        ];
      case 'dataset':
        return [
          {
            name: 'datasetId',
            label: '数据集ID',
            type: 'input' as const,
            rules: [{ required: true, message: '请输入数据集ID' }],
          },
          {
            name: 'name',
            label: '数据集名称',
            type: 'input' as const,
            rules: [{ required: true, message: '请输入数据集名称' }],
          },
        ];
      case 'field':
        return [
          {
            name: 'fieldId',
            label: '字段ID',
            type: 'input' as const,
            rules: [{ required: true, message: '请输入字段ID' }],
          },
          {
            name: 'fieldName',
            label: '字段名称',
            type: 'input' as const,
            rules: [{ required: true, message: '请输入字段名称' }],
          },
          {
            name: 'fieldType',
            label: '字段类型',
            type: 'input' as const,
            rules: [{ required: true, message: '请输入字段类型' }],
          },
        ];
      default:
        return [];
    }
  }, [type]);

  const handleSubmit = async () => {
    if (!formRef) return;
    try {
      const values = await formRef.validateFields();
      // TODO: 调用添加 API
      console.log('添加节点:', type, values, parent);
      message.success('添加成功（Mock 模式）');
      formRef.resetFields();
      onSuccess();
    } catch (error: any) {
      if (error?.errorFields) return;
      message.error(error?.message || '添加失败');
    }
  };

  const getTitle = () => {
    const labels: Record<string, string> = {
      page: '添加页面',
      component: '添加组件',
      dataset: '关联数据集',
      field: '添加字段',
    };
    return labels[type] || '添加节点';
  };

  return (
    <ContainerModal
      title={getTitle()}
      visible={visible}
      onCancel={onCancel}
      width={500}
      height="auto"
      contentPadding={{ vertical: 24, horizontal: 16 }}
      footerRightButtons={[
        {
          key: 'cancel',
          text: '取消',
          type: 'default',
          onClick: onCancel,
        },
        {
          key: 'submit',
          text: '确定',
          type: 'primary',
          onClick: handleSubmit,
        },
      ]}
    >
      <CompsForm
        formItems={formItems}
        formRef={setFormRef}
        layout="horizontal"
        contentPadding={0}
      />
    </ContainerModal>
  );
};

export default AddNodeModal;
